var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1527_1656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.5556C0 18.5127 0.352063 20.3875 0.995188 22.1208L16 23.5121L31.0048 22.1208C31.6479 20.3875 32 18.5127 32 16.5556C32 14.5985 31.6479 12.7237 31.0048 10.9904L16 9.59912L0.995188 10.9904C0.352063 12.7237 0 14.5985 0 16.5556H0Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0047 10.9905C28.7441 4.89773 22.8794 0.555664 15.9999 0.555664C9.12049 0.555664 3.25581 4.89773 0.995117 10.9905H31.0047Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.995117 22.1208C3.25581 28.2136 9.12049 32.5557 15.9999 32.5557C22.8794 32.5557 28.7441 28.2136 31.0047 22.1208H0.995117Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1527_1656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.555664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/spain.5b732b65b681b8dbf0b478df6e2937cc.svg";
export { ForwardRef as ReactComponent };